import {
  confirmResetPassword,
  confirmSignIn,
  confirmUserAttribute,
  fetchAuthSession,
  fetchUserAttributes,
  getCurrentUser,
  resetPassword,
  sendUserAttributeVerificationCode,
  signIn,
  signOut,
} from "aws-amplify/auth";

export const authApi = {
  // Session & JWT
  getSession: async () => {
    return await fetchAuthSession();
  },

  getJwt: async () => {
    try {
      const session = await fetchAuthSession();
      return session?.tokens?.accessToken?.toString();
    } catch {
      return undefined;
    }
  },

  // User
  getCurrentUser: async () => {
    try {
      return await getCurrentUser();
    } catch {
      return null;
    }
  },

  getUserAttributes: async () => {
    try {
      return await fetchUserAttributes();
    } catch {
      return null;
    }
  },

  // Auth actions
  signIn: async (username: string, password: string) => {
    return await signIn({ username, password });
  },

  signOut: async () => {
    return await signOut();
  },

  completeNewPassword: async (password: string) => {
    return await confirmSignIn({ challengeResponse: password });
  },

  // Email verification
  sendEmailVerification: async () => {
    return await sendUserAttributeVerificationCode({
      userAttributeKey: "email",
    });
  },

  verifyEmail: async (confirmationCode: string) => {
    return await confirmUserAttribute({
      userAttributeKey: "email",
      confirmationCode,
    });
  },

  // Password reset
  forgotPassword: async (username: string) => {
    return await resetPassword({ username });
  },

  forgotPasswordSubmit: async (
    username: string,
    confirmationCode: string,
    newPassword: string
  ) => {
    return await confirmResetPassword({
      username,
      confirmationCode,
      newPassword,
    });
  },
};
